module.exports = __webpack_public_path__ + "img/bg-login.22cb9de3.png";